<template>
  <div>
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <el-input data-vv-validate-on="blur"
              v-validate="'required'"
              name="password"
              placeholder="Password"
              v-model="password"
              class="mt-4"
              show-password>
      <i slot="prefix" class="el-input__icon el-icon-lock"></i>
    </el-input>
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="remember_me" class="mb-3">Remember Me</vs-checkbox>
        <router-link to="/auth/forgot-password">Forgot Password?</router-link>
    </div>
    <div class="flex flex-wrap mb-3">
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      email: '',
      password: '',
      remember_me: true
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },

    loginJWT () {

      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        remember_me: this.remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => {
          this.$vs.loading.close();
          this.$store.commit('UPDATE_IS_FETCHED', true);
        })
        .catch(error => {
          this.$vs.loading.close()

          this.$vs.notify({
            title: 'Unauthorized',
            text: `Email or Password doesn't match with any User`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/auth/register').catch(() => {})
    }
  }
}

</script>

